// Frontend/geniac/src/Components/common/ReadOnlyModal.tsx
// Modal moderne pour informer que l'organisation est en mode lecture seule

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

interface ReadOnlyModalProps {
  isOpen: boolean;
  onClose: () => void;
  resourceType: 'project' | 'architecture';
}

const ReadOnlyModal: React.FC<ReadOnlyModalProps> = ({ isOpen, onClose, resourceType }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const resourceLabel = resourceType === 'project' ? 'projet' : 'architecture';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Fermer"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="p-6">
          {/* Icône */}
          <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full">
            <Lock className="w-8 h-8 text-gray-600" />
          </div>

          {/* Titre */}
          <h3 className="text-xl font-bold text-gray-900 text-center mb-3">
            Création non autorisée
          </h3>

          {/* Message principal */}
          <p className="text-gray-700 text-center mb-4">
            Votre organisation est en <strong>mode lecture seule</strong>. Vous ne pouvez pas créer de nouveau {resourceLabel}.
          </p>

          {/* Information supplémentaire */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 text-center">
              Contactez le support ou mettez à jour votre abonnement pour retrouver l'accès complet.
            </p>
          </div>

          {/* Boutons */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              Fermer
            </button>
            <button
              onClick={() => {
                onClose();
                navigate('/settings/subscription');
              }}
              className="flex-1 px-4 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium"
            >
              Voir l'abonnement
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyModal;
